import type { AssetFolderDoc } from '@bb/domain/dist/schemas';
import axios from 'axios';

export type GetFoldersParams = {
  folderId?: string;
  isAdmin: boolean;
  page: number;
  limit: number;
};

export type GetFoldersResponse = {
  assets: AssetFolderDoc[];
  totalAssets: number;
};

export const getFolders = async ({
  folderId,
  isAdmin,
  page,
  limit,
}: GetFoldersParams) => {
  const { data } = await axios.get<GetFoldersResponse>(`/asset/folder`, {
    params: { folderId, isAdmin, page, limit },
  });

  return data;
};
